<footer class="footerSectionWrap" *ngIf="!mobView">
  <div class="container-xl">
    <div class="row">
      <div class="footerQuickLinksWrap">
        <div class="footer-grid">
          <ul class="footerQuickLinks">
            <h3 class="heading3">{{ 'About' | translate }}</h3>
            <li><a href="https://depwd.gov.in/en/unique-disability-id-udid/" target="_blank"
                title="Know more about UDID">{{ 'Know more about UDID' | translate }}</a></li>
            <li><a href="https://depwd.gov.in/" title="Schemes for Persons with Disabilities">{{
                'Schemes for Persons with Disabilities' | translate }}</a></li>
            <li><a href="https://depwd.gov.in/" title="About Department of 
                        Empowerment of Persons with Disabilities">{{ 'About Department of Empowerment of Persons with
                Disabilities' | translate }} </a></li>
            <!--
              <li><a href="disibility-scheme" title="Disibility schemes">{{ 'Disibility schemes' | translate }}</a></li>

              <li><a href="medicalcamps-hospital" title="Medical Camps / Hospitals">{{ 'Medical Camps / Hospitals' | translate }}</a></li>

              <li><a href="district-wallfare-office" title="Disclaimer welfare office">{{ 'Disclaimer welfare office' | translate }}</a></li>
              -->

          </ul>
        </div>
        <div class="footer-grid secendpart d-none">
          <ul class="footerQuickLinks">
            <h3 class="heading3">Access</h3>
            <li><a href="/terms-and-conditions" title="Terms & Conditions">{{ "Terms & Conditions" | translate }}</a>
            </li>
            <li><a href="/privacy-policy" title="Privacy Policy">{{ "Privacy Policy" | translate }}</a></li>
            <li><a href="/copyright-policy" title="Copyright Policy">{{ "Copyright Policy" | translate }}</a></li>
            <li><a href="/hyperlinking-policy" title="Hyperlinking Policy">{{ "Hyperlinking Policy" | translate }}</a>
            </li>
            <li><a href="/accessibility-statement" title="Accessibility Statement">{{ "Accessibility Statement" |
                translate }}</a></li>
            <li><a href="/accessibility-options" title="Accessibility Options">{{ "Accessibility Options" | translate }}
              </a></li>
            <li><a href="/help" title="Help">{{ "Help" | translate }} </a></li>
          </ul>

          <ul class="footerQuickLinks custompb">

            <!-- <li><a href="/feedback" title="Feedback">Feedback</a></li>
                        <li><a href="/help-desk" title="Help Desk">Help Desk</a></li>
                        <li><a href="/noticens" title="Noticens">Notice</a></li> -->
          </ul>
        </div>



        <div class="footer-grid">
          <ul class="footerQuickLinks">
            <h3 class="heading3">{{"Quick Access Key" |translate}}</h3>
            <li><a href="#" title="H = Go to Home Page">{{"H = Go to Home Page" |translate}}</a></li>
            <li><a href="#" title="S = Skip to main content">{{"S = Skip to main content" |translate}}</a></li>
            <li><a href="#" title="F = Site Search">{{"F = Site Search" |translate}}</a></li>
            <li><a href="#" title="T = Back to Top">{{"T = Back to Top" |translate}}</a></li>
            <li><a href="#" title="G = Help/Guide">{{"G = Help/Guide" |translate}}</a></li>
          </ul>
        </div>
        <div class="footer-grid">
          <ul class="footerQuickLinks mb-0 quickaccess">
            <h4 class="heading4">{{"Use keyboard for quick access" |translate}}</h4>
            <li><a href="#" title="Internet Explorer - [Alt] + accesskey">Internet Explorer - [Alt] + accesskey</a></li>
            <li><a href="#" title="Chrome - [Alt] + accesskey">Chrome - [Alt] + accesskey</a></li>
            <li><a href="#" title="Firefox - [Alt] [Shift] + accesskey">Firefox - [Alt] [Shift] + accesskey</a></li>
            <li><a href="#" title="Safari - [Alt] + accesskey">Safari - [Alt] + accesskey</a></li>
            <li><a href="#" title="Mac - [Ctrl] + accesskey">Mac - [Ctrl] + accesskey</a></li>
          </ul>
        </div>
      </div>
    </div>

  </div>

  <div class="copyright-bg">
    <div class="container-xl">
      <div class="row">
        <div class="copyright">
          <div class="row">
            <div class="col-md-12 col-lg-8">
              <ul>
                <li><a href="/terms-and-conditions" title="Terms & Conditions">{{ "Terms & Conditions" | translate
                    }}</a></li>
                <li><a href="/privacy-policy" title="Privacy Policy">{{ "Privacy Policy" | translate }}</a></li>
                <li><a href="/copyright-policy" title="Copyright Policy">{{ "Copyright Policy" | translate }}</a></li>
                <li><a href="/hyperlinking-policy" title="Hyperlinking Policy">{{ "Hyperlinking Policy" | translate
                    }}</a></li>
                <li><a href="/accessibility-statement" title="Accessibility Statement">{{ "Accessibility Statement" |
                    translate }}</a></li>
                <li><a href="/accessibility-options" title="Accessibility Options">{{ "Accessibility Options" |
                    translate }} </a></li>
                <!-- <li><a href="/disclaimer" title="Disclaimer">{{ "Disclaimer" | translate }}</a></li>   -->
                <li><a href="/help" accesskey="g" title="Help">{{ "Help" | translate }} </a></li>
                <li><a href="/Web-information-manager" title="Web Information Manager">{{ "Web Information Manager" |
                    translate }}</a></li>
              </ul>
              <p class="copyrighttext mt-2">© Copyright 2024 Unique Disability ID, Department of Empowerment of Persons
                with Disabilities,<br />
                Ministry of Social Justice & Empowerment, Govt. of India. All Rights Reserved.<br />
              </p>
            </div>
            <div class="col-md-12 col-lg-2">
              <div class="schemes-application">
                <div class="social-media">
                  <a title="Twitter" class="twitter"
                    href="https://x.com/socialpwds?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"><span><img
                        src="assets/images/x.png" target="_blank" alt="twitter">
                      <div class="d-none">twitter</div>
                    </span></a>
                  <a title="Facebook"
                    href="https://www.facebook.com/DoEPWD?rdid=p5RnEYwrelYRVzxy&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1CimVupYpc%2F#"><span
                      class="fa-brands fa-facebook-f" target="_blank">
                      <div class="d-none">facebook</div>
                    </span></a>
                  <a title="YouTube" href="https://www.youtube.com/c/DEPwDAccessibleIndiaCampaign"><span
                      class="fa-brands fa-youtube" target="_blank">
                      <div class="d-none">youtube</div>
                    </span></a>
                  <a title="Linkeding"
                    href="https://www.linkedin.com/authwall?trk=bf&trkInfo=AQGZXw9_Z0gq-wAAAZRz53RAQMf5JEDirXXVm0Wwy6OuRZC_txDhlQLp15i2q0taJG6WhOKWm6iHXi023iOU80rKWnNq_IEaLNjglUDWOm-YR24AsDy-haN4uTRAsnHwcXWk3ZM=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fin%2Fdivyang-empowerment-291b21278%3Futm_source%3Dshare%26utm_campaign%3Dshare_via%26utm_content%3Dprofile%26utm_medium%3Dandroid_app"><span
                      class="fa-brands fa-linkedin-in" target="_blank">
                      <div class="d-none">linkedin</div>
                    </span></a>
                  <a title="Instagram" href="https://www.instagram.com/socialpwds/?igsh=MWRvc3p1emRranln#"><span
                      class="fa-brands fa-instagram" target="_blank">
                      <div class="d-none">instagram</div>
                    </span></a>
                  <!-- <a href="#"><span class="fa-brands fa-linkedin-in"><div class="d-none">linkedin-in</div></span></a> -->
                </div>
              </div>
              <div class="schemes-application">
                <div class="social-media">
                  <a title="Website Quality Certification" class="Website Quality Certification p-0 w-auto h-auto"
                    href="assets/images/UDIDCertificate.pdf"><span><img src="assets/images/cqw_logo.png" target="_blank"
                        alt="Website Quality Certification">
                      <div class="d-none">Website Quality Certification</div>
                    </span></a>
                </div>
              </div>
            </div>



            <div class="col-md-12 col-lg-2">
              <div class="visitorLastUpdate">
                <p>Updated on: <span>{{ currentDate}}</span></p>
                <!-- <p>Visitors: <span></span></p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <a href="#wrapper" title="Back to top" id="backtotop" accesskey="t"> Back to top</a>
</footer>